import React, { lazy, Suspense, useCallback, useState } from "react";
import { SubHeading } from "../../shared/Components";
import CommonModal from "../../shared/Components/Modal/CommonModal";
import Confirmation from "../../shared/Components/UI/Confirmation";

const MarketTypeBody = lazy(() => import("./MarketTypeBody"));
const MarketType = () => {
  // const [isShow, setIsShow] = useState({
  //   isOpen: false,
  //   rowData: null,
  //   name: "",
  //   modalTitle: "",
  //   modalContent: null,
  //   apiFlag: false,
  // });

  // const handleConfirmModal = useCallback((rowData) => {
  //   setIsShow({
  //     rowData,
  //     isOpen: true,
  //     modalContent: Confirmation,
  //     modalTitle: "Settlement",
  //     modalSize: "md",
  //   });
  // });

  return (
    <>
      <SubHeading isAddBtn={false} isBack={true} />

      <Suspense fallback={<div>Loading...</div>}>
        <MarketTypeBody />
        {/* <MarketTypeBody onConfirmModal={handleConfirmModal} /> */}
      </Suspense>
      {/* {isShow.isOpen && (
        <CommonModal
          isShow={isShow.isOpen}
          handleModalHide={() =>
            setIsShow((prev) => ({
              ...prev,
              isOpen: false,
              rowData: {},
              name: "",
            }))
          }
          modalTitle={isShow.modalTitle}
          size={isShow.modalSize}
        >
          {isShow.modalContent &&
            React.createElement(isShow.modalContent, {
              handleShowHide: () =>
                setIsShow((prev) => ({
                  ...prev,
                  isOpen: false,
                  rowData: {},
                  name: "",
                  modalTitle: "",
                })),
              rowData: isShow.rowData,
            })}
        </CommonModal>
      )} */}
    </>
  );
};

export default MarketType;
